import { ReactComponent as BackArrow } from 'assets/images/back.arrow.svg'

interface PageHeaderProps {
    title: string;
    isArrow?: boolean;
    onBack?: () => void;
}

const PageHeader = ({ title, isArrow, onBack }: PageHeaderProps) => {
    const handleBackClick = () => {
        if (onBack) {
            onBack();
        } else {
            window.history.back();
        }
    }

    return (
        <div className='flex h-[48px] items-center gap-3 mb-1 mobile:px-5'>
            {isArrow && (
                <button
                    className='flex items-center justify-center w-8 h-8 rounded-lg hover:bg-achromatic-100 transition-colors'
                    onClick={handleBackClick}
                >
                    <BackArrow className='w-4 h-4' style={{ stroke: '#374151' }} />
                </button>
            )}
            <h1 className='text-lg font-bold text-achromatic-900'>{title}</h1>
        </div>
    );
}

export default PageHeader;